import StaticAnalysisPage from "@/pages/static-analysis";
<Route path="/clients/:clientCode/static-analysis" component={StaticAnalysisPage} />
import React from "react";
import { Switch, Route } from "wouter";
import Home from "@/pages/home";
import DesignPage from "@/pages/design";
import EnterpriseConfigDemoPage from "@/pages/enterprise-demo";
import UserProfilePage from "@/pages/user-profile";
import BacpacAssessmentReport from "@/pages/BacpacAssessmentReport";
import BacpacFindingsReport from "@/pages/BacpacFindingsReport";
import DiagnosticsPage from "@/pages/DiagnosticsPage";
import SQLToolPage from "@/pages/SQLToolPage";
import SQLWorkspace from "@/components/SQLWorkspace";
import CostcoArchitecturePage from "@/pages/CostcoArchitecturePage";
import DiagnosticPage from "@/pages/diagnostic";
// import StaticAnalysisPage from "@/pages/StaticAnalysisPage";
import NotFound from "@/pages/not-found";
function SQLErrorLogsPage() { return <SQLToolPage tool="error-logs" />; }
import ClientLandingPage from "@/components/ClientLandingPage";
import DatabaseSchemaAnalysisPage from "@/pages/schema-analysis";
import IndexAnalysisPage from "@/pages/index-analysis";
import SettingsPage from "@/pages/SettingsPage";

// SQL Tool wrapper components for routes (must be top-level)
function SQLConfigurationsPage() { return <SQLToolPage tool="configurations" />; }
function SQLDatabaseDesignPage() { return <SQLToolPage tool="database-design" />; }
function SQLSecurityPage() { return <SQLToolPage tool="security" />; }
function SQLPerformancePage() { return <SQLToolPage tool="performance" />; }
import StabilizePage from "@/pages/StabilizePage";
import StressTestingPage from "@/pages/StressTestingPage";
import OperatePage from "@/pages/OperatePage";
import ObservePage from "@/pages/ObservePage";
import PlanPage from "@/pages/plan";
import CodePage from "@/pages/code";
import BuildPage from "@/pages/build";
import VMProfilePage from "@/pages/VMProfilePage";
import WSRPage from "@/pages/WSRPage";
import LandingPage from "@/pages/landing";
import LoginPage from "@/pages/login";
function SQLAlwaysOnPage() { return <SQLToolPage tool="alwayson" />; }
function SQLMaintenancePage() { return <SQLToolPage tool="maintenance" />; }
function SQLPropertiesPage() { return <SQLToolPage tool="properties" />; }
function SQLExcellencePage() { return <SQLToolPage tool="excellence" />; }
import AboutPage from "@/pages/about";
import WorkspacePage from "@/pages/workspace";


const AppRoutes = () => (
  <Switch>
    <>
      <Route path="/" component={LandingPage} />
      <Route path="/about" component={AboutPage} />
      <Route path="/login" component={LoginPage} />
      <Route path="/workspace" component={WorkspacePage} />
      <Route path="/dashboard" component={Home} />
      <Route path="/plan" component={PlanPage} />
      <Route path="/code" component={CodePage} />
      <Route path="/build" component={BuildPage} />
      <Route path="/vm-profile" component={VMProfilePage} />
      <Route path="/wsr" component={WSRPage} />
      <Route path="/design" component={DesignPage} />
      <Route path="/enterprise-demo" component={EnterpriseConfigDemoPage} />
      <Route path="/user-profile" component={UserProfilePage} />
      <Route path="/clients/:clientCode/bacpac-assessment-report" component={BacpacAssessmentReport} />
      <Route path="/bacpac-findings-report" component={BacpacFindingsReport} />
      <Route path="/clients/:clientCode/diagnostics" component={DiagnosticsPage} />
      <Route path="/diagnostics" component={DiagnosticsPage} />
      {/* SQL Tools Routes */}
      <Route path="/sql/configurations" component={SQLConfigurationsPage} />
      <Route path="/sql/database-design" component={SQLDatabaseDesignPage} />
      <Route path="/sql/security" component={SQLSecurityPage} />
      <Route path="/sql/performance" component={SQLPerformancePage} />
      <Route path="/sql/error-logs" component={SQLErrorLogsPage} />
      <Route path="/sql/alwayson" component={SQLAlwaysOnPage} />
      <Route path="/sql/maintenance" component={SQLMaintenancePage} />
      <Route path="/sql/properties" component={SQLPropertiesPage} />
      <Route path="/sql/excellence" component={SQLExcellencePage} />
      {/* Client-aware SQL Tools Routes */}
      <Route path="/clients/:clientCode/sql/configurations" component={SQLConfigurationsPage} />
      <Route path="/clients/:clientCode/sql/database-design" component={SQLDatabaseDesignPage} />
      <Route path="/clients/:clientCode/sql/security" component={SQLSecurityPage} />
      <Route path="/clients/:clientCode/sql/performance" component={SQLPerformancePage} />
      <Route path="/clients/:clientCode/sql/error-logs" component={SQLErrorLogsPage} />
      <Route path="/clients/:clientCode/sql/alwayson" component={SQLAlwaysOnPage} />
      <Route path="/clients/:clientCode/sql/maintenance" component={SQLMaintenancePage} />
      <Route path="/clients/:clientCode/sql/properties" component={SQLPropertiesPage} />
      <Route path="/clients/:clientCode/sql/excellence" component={SQLExcellencePage} />
      <Route path="/clients/:clientCode/sql/management" component={SQLWorkspace} />
      {/* Costco Architecture Configuration Route */}
      <Route path="/clients/COSTCO/architecture" component={CostcoArchitecturePage} />
      {/* Client-aware general routes */}

      <Route path="/clients/:clientCode/stabilize/load" component={StabilizePage} />
      <Route path="/clients/:clientCode/stabilize/endurance" component={StabilizePage} />
      <Route path="/clients/:clientCode/stabilize/spike" component={StabilizePage} />
      <Route path="/clients/:clientCode/stabilize/analysis" component={StabilizePage} />
      <Route path="/clients/:clientCode/stabilize/success-criteria" component={StabilizePage} />
      <Route path="/clients/:clientCode/stabilize" component={StabilizePage} />
      <Route path="/clients/:clientCode" component={ClientLandingPage} />
      <Route path="/clients/:clientCode/discovery" component={DiagnosticPage} />
      <Route path="/clients/:clientCode/static-analysis" component={StaticAnalysisPage} />
      <Route path="/clients/:clientCode/findings" component={StaticAnalysisPage} />
      <Route path="/clients/:clientCode/reports" component={BacpacAssessmentReport} />
      <Route path="/clients/:clientCode/reports/:reportType" component={BacpacAssessmentReport} />
      <Route path="/clients/:clientCode/stabilize/stress" component={StressTestingPage} />
      <Route path="/clients/:clientCode/plan" component={PlanPage} />
      <Route path="/clients/:clientCode/code" component={CodePage} />
      <Route path="/clients/:clientCode/build" component={BuildPage} />
      <Route path="/clients/:clientCode/vm-profile" component={VMProfilePage} />
      <Route path="/clients/:clientCode/wsr" component={WSRPage} />
      <Route path="/clients/:clientCode/operate" component={OperatePage} />
      <Route path="/clients/:clientCode/observe" component={ObservePage} />
      <Route path="/clients/:clientCode/schema-analysis" component={DatabaseSchemaAnalysisPage} />
      <Route path="/clients/:clientCode/index-analysis" component={IndexAnalysisPage} />
      {/* Global Settings */}
      <Route path="/settings" component={SettingsPage} />
      <Route path="/clients/:clientCode/settings" component={SettingsPage} />
    </>
  </Switch>
);

export default AppRoutes;
